const MENU_RESTORE_ATTEMPTS = 50;
const MENU_RESTORE_DELAY_MS = 100;

// A nextTick-only retry prevents async submenus from finishing their fetch.
function restoreChildMenu(show, attemptsLeft = MENU_RESTORE_ATTEMPTS) {
    if (this._isDestroyed || this._isBeingDestroyed) {
        return;
    }

    this.$nextTick(() => {
        const childMenu = this.childMenu();
        if (childMenu) {
            childMenu.show = show;
            return;
        }

        if (!Array.isArray(this.items) || !this.items.length || attemptsLeft <= 0) {
            return;
        }

        window.setTimeout(() => this.setChildMenuShow(show, attemptsLeft - 1), MENU_RESTORE_DELAY_MS);
    });
}

export function installMenuStateFix() {
    Vue.mixin({
        beforeCreate() {
            if (this.$options._componentTag !== 'ak-menu-item') {
                return;
            }

            this.$options.methods = {
                ...this.$options.methods,
                setChildMenuShow: restoreChildMenu,
            };
        },
    });
}
